module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-3-b2045ca7e6d7e7c910d74e12a273070e.webp";